import { Code } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { advicesApi } from '../../apis/advices.api';

export function useUpdateWheat2Advice() {
  const { t } = useTranslation();

  return useMutation({
    mutationKey: ['advices', 'wheat2', 'update'],
    mutationFn: advicesApi.updateWheat2,
    onError: (error) => {
      notifications.show({
        title: t('common.error.title'),
        message: <Code>{error.message}</Code>,
        color: 'red',
        withCloseButton: true,
        autoClose: 10000,
      });
    },
  });
}

export default useUpdateWheat2Advice;
